import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react'
import { Button } from '@mui/material'

const LogoutButton = () => {
    const { logout } = useAuth0();
  
    return (
      <Button variant="outlined"  onClick={() => logout({ returnTo: window.location.origin })}>
          Logout
    </Button>
    );
  };

const AccountPage = () => {

    const { user } = useAuth0();

    return (
        <>
        <h2>Account Info</h2>
        <div>
            {(user &&
            <>
                <p><b>User</b>: {user.nickname}</p>
                <p><b>Email</b>: {user.email}</p>
            </>
            )}
            
        </div>
        <LogoutButton></LogoutButton>
        </> 
        
        )
    }

export default withAuthenticationRequired(AccountPage)
